import { render, staticRenderFns } from "./MIAccessCharges.vue?vue&type=template&id=56c60dc8&scoped=true"
import script from "./MIAccessCharges.vue?vue&type=script&lang=js"
export * from "./MIAccessCharges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c60dc8",
  null
  
)

export default component.exports